var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExternalLinkIcon } from '@marketing-icons';
import Heading from '@marketing/components/global/typography/Heading';
import { clsx } from 'clsx';
import Image from '../../Media/Image';
function PressQuote(_a) {
    var headline = _a.headline, externalLink = _a.externalLink, quote = _a.quote, imageData = _a.imageData;
    return (_jsx("a", __assign({ href: externalLink, target: "_blank", rel: "noopener noreferrer", className: clsx(!externalLink && 'pointer-events-none no-underline') }, { children: _jsxs("div", __assign({ className: "w-full p-xs-m bg-surface-white rounded-md md:rounded-[10px] border border-state-inactive-light" }, { children: [_jsxs("div", __assign({ className: "flex justify-between items-start" }, { children: [_jsx(Image, { className: "w-[87px] h-[66px] !rounded-none", imageData: imageData }), externalLink && _jsx(ExternalLinkIcon, { className: "text-icon-dark" })] })), headline && (_jsx(Heading, __assign({ size: "sm", className: "mt-lg-m md:mt-xl-m" }, { children: headline }))), _jsx("p", __assign({ className: "mt-xs-m" }, { children: quote }))] })) })));
}
export default PressQuote;
